/* eslint-disabled */
import Partner from "./Partner";
import PaymentTransaction from "./PaymentTransaction";
import Account from "./Account";
import PaymentMethodExtend from "@/entity/extends/PaymentMethodExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class PaymentMethod extends PaymentMethodExtend {

public id!: number;
public label = '';
public slug = '';
public active!: boolean;
public partners: Array<Partner> = [];
public transactions: Array<PaymentTransaction> = [];
public requireManagerValidation?: boolean;
public requirePhoneNumber?: boolean;
public uuid? = '';
public createdAt? = '';
public updatedAt? = '';
public createBy? = '';
public updateBy? = '';
public removeBy? = '';
public createdFromIp? = '';
public updatedFromIp? = '';
public photo? = '';
public alt? = '';
public ranking? = '';
public account!: Account;

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.slug= object.slug;
       this.active= object.active;
            hydrateCollection(object.partners, Partner, this.partners);
            hydrateCollection(object.transactions, PaymentTransaction, this.transactions);
       this.requireManagerValidation= object.requireManagerValidation;
       this.requirePhoneNumber= object.requirePhoneNumber;
       this.uuid= object.uuid;
       this.createdAt= object.createdAt;
       this.updatedAt= object.updatedAt;
       this.createBy= object.createBy;
       this.updateBy= object.updateBy;
       this.removeBy= object.removeBy;
       this.createdFromIp= object.createdFromIp;
       this.updatedFromIp= object.updatedFromIp;
       this.photo= object.photo;
       this.alt= object.alt;
       this.ranking= object.ranking;
this.account = (object.account instanceof Account) ? object.account : object.account ? new Account(object.account) : object.account;
      }
      this.postConstruct()
  }

}
